module.exports = __webpack_public_path__ + "static/img/14.5f11de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/14.png
// module id = aY1j
// module chunks = 0